const config = Object.assign({ siteName: "NuORDER" }, process.env.CONFIG, (window as any).NUCONFIG || {});
((window || {}) as any).nuConfig = config;
export const getConfig = () => config;
export default config;
